<template>
    <div ref="conradio" :style="styleLabel" :class="[`vs-input-${color}`, { isFocus: isFocus }]">
        <label class="vs-input--label" v-html="label_text"></label>
        <ul class="flex flex-wrap" :class="{ vertical: vertical }">
            <li v-for="(option, index) in options" :key="index">
                <vs-radio
                    v-if="hasValidation"
                    :value="value"
                    :vs-name="_uid"
                    :name="name"
                    :vs-value="valueKey ? option[valueKey] : option"
                    v-validate="`${validationRule}`"
                    class="mt-1 mr-6"
                    v-on="listeners"
                >
                    <slot name="option" :option="option">
                        <span v-html="textKey ? option[textKey] : option"></span>
                    </slot>
                </vs-radio>
                <vs-radio
                    v-else
                    :value="value"
                    :vs-name="_uid"
                    :name="name"
                    :vs-value="valueKey ? option[valueKey] : option"
                    class="mt-1 mr-6"
                    v-on="listeners"
                >
                    <slot name="option" :option="option">
                        <span v-html="textKey ? option[textKey] : option"></span>
                    </slot>
                </vs-radio>
            </li>
        </ul>

        <div style="height: 19px">
            <transition-group @before-enter="beforeEnter" @enter="enter" @leave="leave">
                <div
                    v-if="success"
                    key="success"
                    class="con-text-validation vs-input--text-validation"
                >
                    <span
                        class="span-text-validation span-text-validation-success vs-input--text-validation-span"
                    >
                        {{ successText }}
                    </span>
                </div>
                <div
                    v-else-if="danger"
                    key="danger"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                >
                    <span class="span-text-validation">
                        {{ dangerText }}
                    </span>
                </div>
                <div
                    v-else-if="hasValidationErrors"
                    key="error"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                >
                    <span class="span-text-validation">
                        {{ errorText }}
                    </span>
                </div>
                <div
                    v-else-if="warning"
                    key="warning"
                    class="con-text-validation span-text-validation-warning vs-input--text-validation-span"
                >
                    <span class="span-text-validation">
                        {{ warningText }}
                    </span>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import validationMixins from '@/plugins/validationMixins.js'
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-radio',
    mixins: [validationMixins],
    props: {
        value: {
            type: null
        },
        options: {
            type: Array
        },
        textKey: {
            type: String
        },
        valueKey: {
            type: String
        },
        vertical: {
            type: Boolean,
            default: false
        },
        name: {
            type: String
        },
        label: {
            default: null,
            type: [String, Number]
        },
        color: {
            default: 'primary',
            type: String
        },
        success: {
            default: false,
            type: Boolean
        },
        danger: {
            default: false,
            type: Boolean
        },
        warning: {
            default: false,
            type: Boolean
        },
        size: {
            default: 'normal',
            type: String
        },
        successText: {
            default: null,
            type: String
        },
        dangerText: {
            default: null,
            type: String
        },
        warningText: {
            default: null,
            type: String
        }
    },
    data: () => ({
        isFocus: false
    }),
    computed: {
        style() {
            return {
                border: `1px solid ${
                    this.isFocus ? _color.getColor(this.color, 1) : 'rgba(0, 0, 0,.2)'
                }`
            }
        },
        styleLabel() {
            return {
                color: this.isFocus ? _color.getColor(this.color, 1) : null
            }
        },
        listeners() {
            return {
                ...this.$listeners,
                input: (val) => {
                    this.$emit('input', val)
                },
                focus: (evt) => {
                    this.$emit('focus', evt)
                    this.changeFocus(true)
                },
                blur: (evt) => {
                    this.$emit('blur', evt)
                    this.changeFocus(false)
                }
            }
        }
    },
    methods: {
        changeFocus(booleanx) {
            this.isFocus = booleanx
        },
        // animation
        beforeEnter(el) {
            el.style.height = 0
        },
        enter(el, done) {
            let h = el.scrollHeight
            el.style.height = h + 'px'
            done()
        },
        leave: function (el) {
            el.style.height = 0 + 'px'
        }
    }
}
</script>

<style>
.vertical > li {
    width: 100%;
}
</style>
